<template>
  <ValidationObserver ref="form">
    <div>
      <RecordControlBar v-if="item"
                        v-model="item"
                        :readOnly="readOnly"
                        :isFinished="isFinished"
                        @edit-click="toggleReadOnly"
                        @cancel-click="onCancel($event)"
                        v-stream:submit-click="onSubmit$"
                        v-stream:resubmit-click="onResubmit$"
                        :role="role"
                        :deletedBy="user.username"
                        :validate="validate">
      </RecordControlBar>
      <div v-if="item">
        <div class="setting-section-block">
          <div class="section">
              <b-form @submit.prevent>
                <h4 class="title">匯款紀錄<span class="must-fill-label">*必須填寫</span></h4>
                  <AGCInput
                    :value="nameId"
                    name="商戶名稱/編號"
                    rules="required|max:50"
                    class="mb-3 custom-input"
                    placeholder="商戶名稱/編號"
                    style="background: none;"
                    required
                    disabled
                    label="商戶名稱/編號"
                    autofocus
                  ></AGCInput>
                  <div class="mb-3 custom-input">
                    <AGCLabel required>帳單日期</AGCLabel>
                      <br />
                    <AGCDateTimePicker
                      :value="billDate"
                      disabled
                      hasRange
                      rules="required"
                      name="帳單日期"
                      class="custom-date mr-3"
                      style="display:block;"
                    ></AGCDateTimePicker>
                  </div>
                  <div md="12" class="mb-3 custom-input" v-if="isFinished">
                    <AGCLabel required>匯款日期</AGCLabel>
                      <br />
                    <AGCDateTimePicker
                      v-model="item.transferDate"
                      rules="required"
                      :disabled="readOnly"
                      name="匯款日期"
                      class="custom-date mr-3"
                      style="display:block;"
                    ></AGCDateTimePicker>
                  </div>
                  <AGCInput
                      v-model.trim="item.amount"
                      name="銷售額"
                      rules="required"
                      class="mb-3 custom-input"
                      placeholder="銷售額"
                      required
                      disabled
                      label="銷售額"
                      autofocus
                      prepend="HK$"
                  ></AGCInput>
                  <AGCInput
                      v-model.trim="item.profit"
                      name="商戶將收取之款項"
                      rules="required|max:10"
                      class="mb-3 custom-input"
                      placeholder="商戶將收取之款項"
                      required
                      disabled
                      label="商戶將收取之款項"
                      autofocus
                      prepend="HK$"
                    ></AGCInput>
                  <AGCInput
                      v-if="isFinished"
                      v-model.trim="item.others"
                      name="其他費用"
                      rules="max:10"
                      class="mb-3 custom-input"
                      placeholder="其他費用"
                      :disabled="readOnly"
                      label="其他費用"
                      autofocus
                      prepend="HK$"
                    ></AGCInput>
                    <DropZone
                      v-if="isFinished"
                      v-model="item.statement"
                      :acceptedFiles="'.pdf'"
                      :read-only="readOnly"
                      rules="required"
                      name="月結單"
                      class="mb-3 custom-input"
                      upload-type="statement"
                      label="月結單"
                      id="pdf"
                      sub-label="(最多1個PDF, 每個上限2mb)"
                      required
                    ></DropZone>
                    <ContentEditor
                      v-if="isFinished"
                      v-model="item.remarks"
                      name="備註"
                      label="備註"
                      class="mb-3 custom-input"
                      :read-only="readOnly"
                      :toolbar= "toolbarValue"
                    ></ContentEditor>
              </b-form>
          </div>
        </div>
      </div>
      <LoadingSpinner v-show="loading"></LoadingSpinner>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import {
  map,
  tap,
  pluck,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import http from '@/helpers/http';
import {
  BForm,
} from 'bootstrap-vue';
import cloneDeep from 'lodash.clonedeep';
import getStatus from '@/helpers/status';
import RecordControlBar from '@/components/record/RecordControlBar.vue';
import imagePath from '@/filters/image-path';
import formMixin from '@/mixins/form';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import DropZone from '@/components/form/DropZone.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import LoadingSpinner from '../../components/LoadingSpinner.vue';
import { getErrorMsg } from '../../helpers/error-msg';
import toastSettings from '../../helpers/toast-settings';

const initialState = {
  id: '',
  recordId: '',
  merchantName: '',
  merchantId: '',
  amount: '',
  profit: '',
  createAt: null,
  startDate: '',
  endDate: '',
  transferDate: '',
  remarks: '',
  others: '',
  status: '',
};
export default {
  mixins: [formMixin],
  props: {
    publicApi: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RecordControlBar,
    BForm,
    AGCInput,
    AGCDateTimePicker,
    ContentEditor,
    DropZone,
    AGCLabel,
    LoadingSpinner,
  },
  data: () => ({
    isEditMerchant: true,
    cropperModal: {
      show: false,
      image: null,
    },
    t: null,
    title: '',
    toolbarValue: [`
      undo redo |
      bold italic underline |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent |
      link |
    `],
    readOnly: true,
    loading: false,
    couponStateBeforeUpdate: null,
  }),
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
    backUrl() {
      return this.role === 'admin' ? '/admin/paymentRecords' : null;
    },
    id() {
      return this.$route.params.id;
    },
    status() {
      return getStatus(this.item);
    },
    apiUrl() {
      return this.role === 'admin' ? '/agc-admin-api/paymentrecord/details/' : '/agc-merchant-api/paymentrecord/details/';
    },
    hideCheckStatus() {
      if (this.role === 'merchant') {
        return true;
      }
      return false;
    },
    userClass() {
      return this.user.class;
    },
    nameId() {
      return `${this.item.merchantName} / ${this.item.merchantId}`;
    },
    billDate() {
      return [this.item.fromDate, this.item.toDate];
    },
    isFinished() {
      return this.item.status === 'FINISHED';
    },
  },
  domStreams: ['onSubmit$', 'onResubmit$'],
  subscriptions() {
    const getData$ = (id) => http({
      method: 'GET',
      url: this.apiUrl + id,
    });

    const submit$ = (data) => http(
      {
        method: 'POST',
        url: `/agc-${this.role}-api/paymentrecord/submit`,
        data,
      },
      {
        error: ({ data: { msg } }) => {
          this.$bvToast.toast(getErrorMsg(msg), {
            ...toastSettings,
            title: '提交失敗',
            toaster: 'b-toaster-top-center',
          });
        },
        next: () => {
          this.readOnly = true;
          this.$nextTick(() => {
            this.$refs.form.reset();
          });
          this.$bvModal.show('coupon-submit-success-modal');
          this.$bvModal.hide('coupon-preview-modal');
        },
        complete: () => {
          this.loading = false;
        },
      },
    );

    const resubmit$ = (data) => http(
      {
        method: 'POST',
        url: `/agc-${this.role}-api/paymentrecord/resubmit`,
        data,
      },
      {
        error: ({ data: { msg } }) => {
          this.$bvToast.toast(getErrorMsg(msg), {
            ...toastSettings,
            title: '提交失敗',
            toaster: 'b-toaster-top-center',
          });
        },
        next: () => {
          this.readOnly = true;
          this.$nextTick(() => {
            this.$refs.form.reset();
          });
          this.$bvModal.show('coupon-submit-success-modal');
          this.$bvModal.hide('coupon-preview-modal');
        },
        complete: () => {
          this.loading = false;
        },
      },
    );

    return {
      onSubmit: this.onSubmit$.pipe(
        switchMap(() => this.validate({ isScrollToTopIfFail: true })),
        tap(() => {
          this.loading = true;
        }),
        map(() => ({
          ...this.item,
        })),
        switchMap(submit$),
      ),

      onResubmit: this.onResubmit$.pipe(
        switchMap(() => this.validate({ isScrollToTopIfFail: true })),
        tap(() => {
          this.loading = true;
        }),
        map(() => ({
          ...this.item,
        })),
        switchMap(resubmit$),
      ),

      item: this.$watchAsObservable('id').pipe(
        pluck('newValue'),
        startWith(this.id),
        switchMap((id) => {
          if (!id) {
            return of(
              cloneDeep({
                ...initialState,
              }),
            );
          }
          return getData$(id);
        }),
        tap((res) => {
          this.couponStateBeforeUpdate = cloneDeep(res);
        }),
      ),
    };
  },
  filters: {
    imagePath,
  },
  methods: {
    reloadImages() {
      this.t = new Date().getTime();
    },
    handleEdit(image) {
      this.cropperModal = {
        show: true,
        image,
      };
    },
    toggleReadOnly() {
      this.readOnly = !this.readOnly;
    },
    onCancel() {
      this.toggleReadOnly();
      this.$refs.form.reset();
      this.item = cloneDeep({
        ...this.couponStateBeforeUpdate,
        currentStatus: { ...this.item.currentStatus },
      });
    },
  },
  mounted() {
    if (this.$route.name === 'AddRecord') {
      this.readOnly = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.section-header {
  position: sticky;
  background: #fafdff;
  z-index: 30;
}

.setting-section-block{
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #DDE1E5;
  border-radius: 4px;
  overflow: hidden;
  margin: auto;
  max-width: 800px;
  margin-bottom: 10px;

  @include respond(phone) {
    margin: 10px 10px;
    .title{
      font-size: 1rem;
    }
  }

  label {
    font-weight: 400;
    font-size: 15px;
  }

  .section {
    width:100%;
    display:inline-block;
    position: relative;
    min-height: 65px;
    padding:20px 20px;
    box-sizing:border-box;

    .custom-input{
      @media (max-width: 1200px) {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-bottom: 10px;
        border-bottom: 1px solid #E0E0E0;
      }

      &::v-deep {
          @media (max-width: 1200px) {
            input {
              border: none;
              background: none;
              padding: 0px;
              font-size: 14px;
            }

            label {
              margin: 0px;
              width: 30%;
              font-size: 14px;
            }

            fieldset {
              width: 60%;
              font-size: 14px;
            }

            img {
              display: none;
            }

            p{
              margin: 0px;
            }

            .input-group-text {
              background: none;
              border: none;
              font-size: 14px;
              padding: 0px;
            }

            .mx-input {
              box-shadow: unset;
            }

            .mx-datepicker-range {
              max-width: 200px;
            }
        }

        @media (max-width: 330px) {
          label {
            width: 100%;
          }
        }
      }
    }
  }
}

.info {
  .my-4 {
    margin-top: 32px !important;
    margin-bottom: 0px !important;
  }

  div:first-child {
    .my-4 {
      margin-top: 12px !important;
    }
  }
}

#password {
  .row{
    padding: 20px 0 10px 0 !important;
    margin-bottom: 32px;
  }
}

.must-fill-label {
  float: right;
  font-size: 14px;
  color: #f54b4e;
  font-weight: 400;

  @media (max-width: 576px) {
    display: none;
  }
}

</style>
